import {AfterViewInit, Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-barcode',
  templateUrl: './barcode.component.html',
  styleUrls: ['./barcode.component.css']
})
export class BarcodeComponent implements AfterViewInit {

  @Input() barcode: string | number;

  @Input() width: number;
  @Input() height: number;

  constructor() {
  }

  ngAfterViewInit(): void {
    (window as any).JsBarcode('#code-' + this.barcode, this.barcode, {
      width: this.width,
      height: this.height
    });
  }
}
